const env = process.env.NODE_ENV
// 开发环境运行命令：npm run serve
// 生产环境打包命令：npm run pro
// 测试环境打包命令：npm run build
const IP = {
  development: { // 本地开发环境
    baseIP: 'https://dev.spbcn.org/erp_test/' // -------测试
    // baseIP: 'https://dev.spbcn.org/erp/' // -------正式
    // baseIP: 'http://192.168.0.98:8092/erp_test/' // -----local
  },
  production: { // 生产环境
    baseIP: 'https://dev.spbcn.org/erp/'
  },
  test: { // 测试环境
    baseIP: 'https://dev.spbcn.org/erp_test/'
    // baseIP: 'http://47.93.178.140:9666/applets_dev/'
  }
}
export default IP[env]
